import { creatorLightTheme } from '@spotify-internal/encore-web';
import { defaultTheme, MODULE_THEMES } from '../features/ui/Theme';
export const getModuleBackgroundColor = (mod, activeSlideMap) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const activeMod = ((_a = mod.carouselSlides) === null || _a === void 0 ? void 0 : _a.length) &&
        ((_b = mod.carouselSlides) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
        activeSlideMap
        ? activeSlideMap.get(mod.id || '') || mod
        : mod;
    const legacyCustomTheme = Object.assign(Object.assign({}, defaultTheme), MODULE_THEMES[activeMod.themeName || activeMod.theme || '']);
    if ((_c = activeMod.colors) === null || _c === void 0 ? void 0 : _c.backgroundColor) {
        return (_d = activeMod.colors) === null || _d === void 0 ? void 0 : _d.backgroundColor;
    }
    switch (activeMod === null || activeMod === void 0 ? void 0 : activeMod.contentType) {
        case 'faqLinksModule':
        case 'pageBreakerModule':
        case 'editorialGridModule':
        case 'singleFeatureModule':
        case 'featuredContent2Up':
        case 'featuredContent3up':
            return (_e = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _e === void 0 ? void 0 : _e.background;
        case 'singleTestimonial': {
            if (activeMod.theme === 'whiteOnBlack') {
                return creatorLightTheme.base.background.base;
            }
            return creatorLightTheme.invertedDark.background.base;
        }
        case 'groupTestimonial': {
            if (activeMod.themeName === 'whiteOnBlack') {
                return creatorLightTheme.invertedDark.background.base;
            }
            return creatorLightTheme.base.background.base;
        }
        case 'accordionModule':
        case 'miniCarouselNarrative': {
            if (activeMod.themeName === 'dark') {
                return creatorLightTheme.invertedDark.background.base;
            }
            return creatorLightTheme.base.background.base;
        }
        case 'checklistModule': {
            return ((_f = activeMod.colors) === null || _f === void 0 ? void 0 : _f.theme) === 'light'
                ? creatorLightTheme.base.background.base
                : creatorLightTheme.invertedDark.background.base;
        }
        case 'heroBodyModule':
        case 'headerModule':
            return activeMod.backgroundColor;
        case 'heroNarrativeCover':
        case 'heroNarrativeCarousel':
        case 'heroNarrativeQuoteSlide':
        case 'heroNarrativeTextSlide':
            return (_g = activeMod.colors) === null || _g === void 0 ? void 0 : _g.backgroundColor;
        case 'videoModuleLongBody':
        case 'videoModule':
            return creatorLightTheme.invertedDark.background.base;
        case 'featuredContentModule':
            return (_h = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _h === void 0 ? void 0 : _h.background;
        default:
            if (activeMod === null || activeMod === void 0 ? void 0 : activeMod.backgroundColor) {
                return activeMod.backgroundColor;
            }
            if (activeMod === null || activeMod === void 0 ? void 0 : activeMod.theme) {
                return (_j = creatorLightTheme[activeMod.theme === 'light' ? 'base' : 'invertedDark']) === null || _j === void 0 ? void 0 : _j.background.base;
            }
            if (activeMod === null || activeMod === void 0 ? void 0 : activeMod.themeName) {
                return (_k = legacyCustomTheme === null || legacyCustomTheme === void 0 ? void 0 : legacyCustomTheme.box) === null || _k === void 0 ? void 0 : _k.background;
            }
            return creatorLightTheme.invertedDark.background.base;
    }
};
export const getInitialActiveSlideMap = (allModules) => {
    const initialActiveSlides = allModules === null || allModules === void 0 ? void 0 : allModules.filter((mod) => {
        var _a, _b;
        return mod.id &&
            mod.contentType !== 'singleFeatureModule' &&
            ((_a = mod === null || mod === void 0 ? void 0 : mod.carouselSlides) === null || _a === void 0 ? void 0 : _a.length) &&
            ((_b = mod === null || mod === void 0 ? void 0 : mod.carouselSlides) === null || _b === void 0 ? void 0 : _b.length) > 0;
    }).map((mod) => {
        var _a;
        const firstSlide = mod.contentType === 'heroNarrativeCarousel'
            ? mod
            : (_a = mod === null || mod === void 0 ? void 0 : mod.carouselSlides) === null || _a === void 0 ? void 0 : _a[0];
        return mod.id && firstSlide ? [mod.id, firstSlide] : null;
    }).filter(slideMap => (slideMap === null || slideMap === void 0 ? void 0 : slideMap[0]) && (slideMap === null || slideMap === void 0 ? void 0 : slideMap[1]));
    return (initialActiveSlides === null || initialActiveSlides === void 0 ? void 0 : initialActiveSlides.length) && initialActiveSlides.length > 0
        ? new Map(initialActiveSlides)
        : undefined;
};
export const getGraphicTransitionModuleColors = (modules, graphicTranistionIndex, activeSlideMap) => {
    const moduleAbove = modules[graphicTranistionIndex - 1];
    const moduleBelow = modules[graphicTranistionIndex + 1];
    return {
        topColor: moduleAbove
            ? getModuleBackgroundColor(moduleAbove, activeSlideMap)
            : creatorLightTheme.invertedDark.background.base,
        bottomColor: moduleBelow
            ? getModuleBackgroundColor(moduleBelow, activeSlideMap)
            : creatorLightTheme.invertedDark.background.base,
    };
};
//# sourceMappingURL=graphicTransitionUtils.js.map